import type { MusicTask } from '~/services/musicService'

export type TakeDraft = ReturnType<typeof takeDraft>

/** Presentation-only mapping from an existing generation back into the composer. */
export function takeDraft(task: MusicTask) {
  const req = (task.req || {}) as Record<string, any>
  const music = task.music_data?.[0]
  const prompt = req.gpt_description_prompt || music?.metadata?.gpt_description_prompt || ''
  return {
    mode: prompt ? 'normal' : req.prompt || music?.metadata?.prompt ? 'advanced' : 'normal',
    prompt: prompt || req.description || '',
    lyrics: req.prompt || music?.metadata?.prompt || '',
    title: req.title || req.name || music?.title || '',
    tags: req.tags || req.style || music?.metadata?.tags || '',
    mood: req.moods || '',
    instrumental: task.instrumental,
    voice: req.gender || '',
    duration: ['time_3', 'time_all'].includes(req.task_time) ? req.task_time : 'time_all',
  }
}
